import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'

import Dm from '../images/Dm.svg'
import Wb from '../images/Wb.svg'
import Bb from '../images/Bb.svg'
import Divider from '../images/Divider.svg'
import DividerW from '../images/DividerW.svg'
import Fill from '../images/Fill.svg'

import Wave from '../images/Wave.svg'
import WaveB from '../images/WaveB.svg'

import Calendar from '../images/Calendar.svg'

export const query = graphql`
  query Home {
    home: imageSharp(id: {regex: "/images/Home.png/"}) {
      sizes(quality: 75, maxWidth: 1980, traceSVG: {color: "rgb(217, 217, 217)", threshold: 75}, toFormat: PNG) {tracedSVG src}
    },
    ourStory: imageSharp(id: {regex: "/images/osOverlay.jpg/"}) {
      sizes(quality: 100, maxWidth: 750, traceSVG: {color: "rgb(217, 217, 217)", threshold: 75}, toFormat: PNG) {tracedSVG src}
    },
    news: imageSharp(id: {regex: "/images/Nl.jpg/"}) {
      sizes(quality: 75, maxWidth: 1980, traceSVG: {color: "rgb(217, 217, 217)", threshold: 75}, toFormat: PNG) {tracedSVG src}
    },
    globally: file(relativePath: {eq: "Globally.png"}) {
      globalchild: childImageSharp {
      sizes(quality: 75, maxWidth: 750, toFormat: PNG, traceSVG: {color: "rgb(217, 217, 217)", threshold: 75}) {tracedSVG aspectRatio src}
      }
    },
    nthree: file(relativePath: {eq: "n4.jpg"}) {
      nthreechild: childImageSharp {
      sizes(quality: 100, maxWidth: 750, toFormat: PNG, traceSVG: {color: "rgb(217, 217, 217)", threshold: 75}) {tracedSVG aspectRatio src}
      }
    },
    bdlogo: file(relativePath: {eq: "SBd.png"}) {
      bdlogochild: childImageSharp {
      sizes(quality: 100, maxWidth: 250, toFormat: PNG, traceSVG: {color: "rgb(217, 217, 217)", threshold: 75}) {tracedSVG aspectRatio src}
      }
    },
    wslogo: file(relativePath: {eq: "SWs.png"}) {
      wslogochild: childImageSharp {
      sizes(quality: 100, maxWidth: 400, toFormat: PNG, traceSVG: {color: "rgb(217, 217, 217)", threshold: 75}) {tracedSVG aspectRatio src}
      }
    },
    dmlogo: file(relativePath: {eq: "SDm.png"}) {
      dmlogochild: childImageSharp {
      sizes(quality: 100, maxWidth: 250, toFormat: PNG, traceSVG: {color: "rgb(217, 217, 217)", threshold: 75}) {tracedSVG aspectRatio src}
      }
    },
    clogo: file(relativePath: {eq: "Nl.jpg"}) {
      clogochild: childImageSharp {
      sizes(quality: 100, maxWidth: 250, toFormat: PNG, traceSVG: {color: "rgb(217, 217, 217)", threshold: 75}) {tracedSVG aspectRatio src}
      }
    },
    wtlogo: file(relativePath: {eq: "WtLogo.png"}) {
      wtlogochild: childImageSharp {
      sizes(quality: 100, maxWidth: 300, toFormat: PNG, traceSVG: {color: "rgb(217, 217, 217)", threshold: 75}) {tracedSVG aspectRatio src}
      }
    },
    kcllogo: file(relativePath: {eq: "KclLogo.png"}) {
      kcllogochild: childImageSharp {
      sizes(quality: 100, maxWidth: 300, toFormat: PNG, traceSVG: {color: "rgb(217, 217, 217)", threshold: 75}) {tracedSVG aspectRatio src}
      }
    },
    prabhulogo: file(relativePath: {eq: "PrabhuLogo.png"}) {
      prabhulogochild: childImageSharp {
      sizes(quality: 100, maxWidth: 300, toFormat: PNG, traceSVG: {color: "rgb(217, 217, 217)", threshold: 75}) {tracedSVG aspectRatio src}
      }
    },
    muskanlogo: file(relativePath: {eq: "MuskanLogo.png"}) {
      muskanlogochild: childImageSharp {
      sizes(quality: 100, maxWidth: 300, toFormat: PNG, traceSVG: {color: "rgb(217, 217, 217)", threshold: 75}) {tracedSVG aspectRatio src}
      }
    },
    bone: file(relativePath: {eq: "BlogOne.jpg"}) {
      bonechild: childImageSharp {
      sizes(quality: 100, maxWidth: 800, toFormat: PNG, traceSVG: {color: "rgb(217, 217, 217)", threshold: 75}) {tracedSVG aspectRatio src}
      }
    },
    btwo: file(relativePath: {eq: "BlogTwoThumb.jpg"}) {
      btwochild: childImageSharp {
      sizes(quality: 100, maxWidth: 400, toFormat: PNG, traceSVG: {color: "rgb(217, 217, 217)", threshold: 75}) {tracedSVG aspectRatio src}
      }
    },
    bthree: file(relativePath: {eq: "BlogThreeThumbHome.jpg"}) {
      bthreechild: childImageSharp {
      sizes(quality: 100, maxWidth: 400, toFormat: PNG, traceSVG: {color: "rgb(217, 217, 217)", threshold: 75}) {tracedSVG aspectRatio src}
      }
    },
  }
  `

const IndexPage = ({data:{home, ourStory, globally, nthree, news, bdlogo, wslogo, dmlogo, clogo, wtlogo, kcllogo, prabhulogo, muskanlogo, bone, btwo, bthree}}) => (
  <section>
    <article className='container backImage' style={{backgroundImage:`url("${home.sizes.src}"), url("${home.sizes.tracedSVG}")`}}>
      <div className='full-Width'>
        <div className='half-Width-50 mobBottommargin' style={{paddingTop:'20rem'}}>
          <div style={{display:'block'}}>
            <h1 className='smallerHone'>Nisadhya Digital Marketing Pvt Ltd</h1>
            <img src={Divider} alt="Nisadhya - Divider" style={{margin:'0.75rem 0'}}/><br/>
            <p className='biggerText'>Be where your customers are.</p>
            <p style={{maxWidth:'750px', marginBottom:'0'}}>
            We help you connect your business with potential customer by presenting your story and solutions on the internet through Digital Marketing.
            </p>
          </div>
        </div>
        <div className='half-Width-75' style={{paddingTop:'0rem'}}>
          <Img sizes={globally.globalchild.sizes} alt="Globally" style={{width:'100%'}}/>
        </div>
      </div>
    </article>
    <img src={WaveB} alt="Divider" style={{width:'100%', display:'block'}}/>
    <article style={{background:'#f8f8f8'}}>
      <div className='container'>
        <div className='full-Width'>
          <div className='half-Width-50 paddingRight ourStoryOverlay mobBottommargin' style={{backgroundImage:`url("${ourStory.sizes.src}"), url("${ourStory.sizes.tracedSVG}")`}}>
            <div className='fullWidth homeAbout gradientOverlay'>
              <div style={{display:'block', textShadow: '1px 1px 5px #666'}}>
                <h1 className='smallerHone'>Our Story</h1>
                <img src={DividerW} alt="Nisadhya - Divider" style={{margin:'0.75rem 0'}}/>
                <p className='biggerText'>What we believe in.</p>
                <p style={{marginBottom:'0'}}>Brand story telling is not about pushing advertising, it's about bringing value.</p>
              </div>
            </div>
          </div>
          <div className='half-Width-50'>
            <div style={{display:'block'}}>
              <h1 className='smallerHone'>Something About Us.</h1>
              <img src={Fill} alt="Nisadhya - Divider" style={{margin:'0.75rem 0'}}/>
              <p>Nisadhya Pvt. Ltd is a Nepal based Digital Marketing Company that constantly strives to provide the best
               branding and digital marketing solutions for national and international organizations.</p>
              <Link to='/about/'><button>Learn More</button></Link>
            </div>
          </div>
        </div>
      </div>
    <img src={Wave} alt="Divider" style={{width:'100%', display:'block'}}/>
    </article>
    <article>
      <div className='container'>
        <div className='full-Width'>
          <div className='half-Width-25 mobBottommargin'>
            <div style={{display:'block'}}>
              <h1 className='smallerHone'>Services</h1>
              <img src={Divider} alt="Nisadhya - Divider" style={{margin:'0.75rem 0'}}/>
              <p><span className='biggerText gradient'>Strategy, design and a bit of magic.</span></p>
              <p style={{marginBottom:'0'}}>Nisadhya Pvt. Ltd is a Nepal based Digital Marketing Company that constantly strives to provide the best branding and digital marketing solutions.</p>
            </div>
          </div>
          <div className='half-Width-75 homeServicesContainer paddingLeft spaceBetween' style={{alignItems:'baseline'}}>
            <div className='half-Width-30'>
              <div className='centerAlign homeServices'>
                <Img sizes={dmlogo.dmlogochild.sizes} alt="Social Media's impact on Business" style={{maxWidth:'175px', margin:'0 auto', marginBottom:'.75rem'}}/>
                <Link to="/services/digital-marketing/" className='slide'><span>Digital Marketing</span></Link>
                <img src={Fill} alt="Nisadhya - Divider" style={{margin:'0.75rem auto'}}/>
                Social Media<br/>
                Google Ads<br/>
                SEO
              </div>
            </div>
            <div className='half-Width-30'>
              <div className='centerAlign homeServices'>
                <Img sizes={wslogo.wslogochild.sizes} alt="Social Media's impact on Business" style={{maxWidth:'175px', margin:'0 auto', marginBottom:'.75rem'}}/>
                <Link to="/services/web-solutions/" className='slide'><span>Web Solutions</span></Link>
                <img src={Fill} alt="Nisadhya - Divider" style={{margin:'0.75rem auto'}}/>
                Website Design<br/>
                Website Development<br/>
                Web Hosting
              </div>
            </div>
            <div className='half-Width-30'>
              <div className='centerAlign homeServices' style={{marginBottom:'0'}}>
                <Img sizes={bdlogo.bdlogochild.sizes} alt="Social Media's impact on Business" style={{maxWidth:'175px', margin:'0 auto', marginBottom:'.75rem'}}/>
                <Link to="/services/brand-development/" className='slide'><span>Brand Development</span></Link>
                <img src={Fill} alt="Nisadhya - Divider" style={{margin:'0.75rem auto'}}/>
                Corporate Branding<br/>
                Logo Design<br/>
                Brand Strategy
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
    <img src={WaveB} alt="Divider" style={{width:'100%', display:'block'}}/>
    <article style={{backgroundColor:'#f8f8f8'}}>
      <div className='container'>
        <div style={{display:'block'}}>
          <h1 className='smallerHone'>Clients</h1>
          <img src={Divider} alt="Nisadhya - Divider" style={{margin:'0.75rem 0'}}/>
        </div>
        <div className='full-Width spaceBetween' style={{alignItems:'flex-start'}}>
          <div className='half-Width-20 mobBottommargin'>
            <div style={{display:'block'}}>
            <Img className='clientLogo' sizes={wtlogo.wtlogochild.sizes} alt="Rustic Himalayan Adventure" />
            </div>
          </div>
          <div className='half-Width-20 mobBottommargin'>
            <div style={{display:'block'}}>
            <Img className='clientLogo' sizes={kcllogo.kcllogochild.sizes} alt="Rustic Himalayan Adventure" />
            </div>
          </div>
          <div className='half-Width-20 mobBottommargin'>
            <div style={{display:'block'}}>
            <Img className='clientLogo' sizes={prabhulogo.prabhulogochild.sizes} alt="Rustic Himalayan Adventure" />
            </div>
          </div>
          <div className='half-Width-20'>
            <div style={{display:'block'}}>
            <Img className='clientLogo' sizes={muskanlogo.muskanlogochild.sizes} alt="Rustic Himalayan Adventure" />
            </div>
          </div>
        </div>
      </div>
    <img src={Wave} alt="Divider" style={{width:'100%', display:'block'}}/>
    </article>
    <article>
      <div className='container'>
          <div style={{display:'block'}}>
            <h1 className='smallerHone'>Blog</h1>
            <img src={Divider} alt="Nisadhya - Divider" style={{margin:'.75rem 0'}}/>
          </div>
        <div className='full-Width' style={{alignItems:'flex-start'}}>
          <div className='half-Width-50 mobBottommargin paddingRight'>
            <div style={{display:'block'}}>
            <Img sizes={bthree.bthreechild.sizes} alt="Digital Marketing: Why and how it is your Smartest Move." style={{width:'100%',marginBottom:'.75rem'}}/>
            <h1 className='smallerHone gradient'>Digital Marketing: Why and how it is your Smartest Move.</h1>
            <p style={{display: 'flex', alignItems: 'center', margin:'0.75rem 0 0 0', fontSize:'.9rem'}}>
            <img src={Calendar} alt="Nisadhya - Calendar" style={{width:'1.15rem', marginRight:'.5rem'}}/>14<sup>th</sup> March 2019
            </p>
            <img src={Fill} alt="Nisadhya - Divider" style={{margin:'.75rem 0'}}/>
            <p>Digital marketing as the term suggests is marketing digitally especially through the internet because it's 2019 and everyone is stuck with their mobile devices or any other digital medium.</p>
            <Link to='/blog/digital-marketing-why-and-how-it-is-your-smartest-move/' className='slide gradient'>Read More</Link>
            </div>
          </div>
          <div className='half-Width-50'>
            <div className='full-Width spaceBetween' style={{alignItems:'flex-start'}}>
              <div className='half-Width-45 mobBottommargin'>
                <div style={{display:'block'}}>
                <Img sizes={btwo.btwochild.sizes} alt="Why is Content Marketing important" style={{width:'100%',marginBottom:'.75rem'}}/>
                <h1 className='smallerHone gradient'>Why is Content Marketing important?</h1>
                <p style={{display: 'flex', alignItems: 'center', margin:'0.75rem 0 0 0', fontSize:'.9rem'}}>
                <img src={Calendar} alt="Nisadhya - Calendar" style={{width:'1.15rem', marginRight:'.5rem'}}/>8<sup>th</sup> March 2019
                </p>
                <img src={Fill} alt="Nisadhya - Divider" style={{margin:'.75rem 0'}}/>
                <p>Content marketing is not only about advertising, it is about generating awareness about who you are, what you do and what you can offer.</p>
                <Link to='/blog/why-is-content-marketing-important/' className='slide gradient'>Read More</Link>
                </div>
              </div>
              <div className='half-Width-45'>
                <div style={{display:'block'}}>
                <Img sizes={bone.bonechild.sizes} alt="Why is it important to market your business digitally" style={{width:'100%',marginBottom:'.75rem'}}/>
                <h1 className='smallerHone gradient'>Why is it important to market your business digitally?</h1>
                <p style={{display: 'flex', alignItems: 'center', margin:'0.75rem 0 0 0', fontSize:'.9rem'}}>
                <img src={Calendar} alt="Nisadhya - Calendar" style={{width:'1.15rem', marginRight:'.5rem'}}/>1<sup>st</sup> March 2019
                </p>
                <img src={Fill} alt="Nisadhya - Divider" style={{margin:'.75rem 0'}}/>
                <p>People are more inclined to information over the Internet than other media sources. The Internet has transformed the way we interact, and how we share information, including how we market our businesses.</p>
                <Link to='/blog/why-is-it-important-to-market-your-business-digitally/' className='slide gradient'>Read More</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
    <img src={WaveB} alt="Divider" style={{width:'100%', display:'block'}}/>
    <article style={{backgroundColor:'#f8f8f8'}}>
      <div className='container'>
        <div className='full-Width'>
          <div className='half-Width-50 paddingRight mobBottommargin'>
            <Img sizes={nthree.nthreechild.sizes} alt="Globally" style={{width:'100%'}}/>
          </div>
          <div className="half-Width-50">
            <div style={{display:'block'}}>
              <h1 className='smallerHone'>We Help Your Business To Grow Globally.</h1>
              <img src={Fill} alt="Nisadhya - Divider" style={{margin:'.75rem 0'}}/>
              <p>Nisadhya Pvt. Ltd is a Nepal based Digital Marketing Company that constantly strives to provide the best
               branding and digital marketing solutions for national and international organizations.</p>
               <Link to='/contact/'><button>Contact Us</button></Link>
            </div>
          </div>
        </div>
      </div>
    </article>
    <article className='backImage' style={{backgroundImage:`url("${news.sizes.src}"), url("${news.sizes.tracedSVG}")`, backgroundPosition:'bottom center', backgroundSize:'cover'}}>
      <div className='homeNews' style={{color:'#fff'}}>
        <div className='container'>
          <div className='half-Width-33'>
            <div style={{display:'block'}}>
              <h1 className='smallerHone'>Newsletter</h1>
              <img src={DividerW} alt="Nisadhya - Divider" style={{margin:'.75rem 0'}}/>
              <p style={{marginBottom:'.75rem'}}>Receive Updates and Offers straight in your Inbox.</p>
              <form name="Newsletter" method="POST" data-netlify="true" style={{marginBottom:'0'}}>
                <input type="email" name="email" style={{border:'0'}} required />
                <button type="submit">Sign Up</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </article>
  </section>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js